module.exports = __webpack_public_path__ + "static/media/incident_details.7bc9f14a.png";